import React, { useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import tplHelpers from "../../../helpers/tpl";
import ThirdPartyLogisticsOrdersForm from './ThirdPartyLogisticsOrdersForm';
import moment from 'moment';

function ThirdPartyLogisticsOrders(props) {

    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [orders, setOrders] = useState([]);
    const [totalSalesOrders, setTotalSalesOrders] = useState("");
    const [totalQuantity, setTotalQuantity] = useState("");
    const [totalCost, setTotalCost] = useState("");
    const [warehouse, setWarehouse] = useState("");
    const [customer, setCustomer] = useState("");

    const handleDateChange = (date, field) => {
        let func = setStartDate;
        if (field === "endDate") func = setEndDate;
        if (date !== null) {
            func({formatted: date.format("YYYY-MM-DD"), full: date});
        } else {
            func(date);
        }
    };

    const warehouse_options = [
        {value: 10, name: 'Geodis'},
        {value: 50, name: 'Pet Factory'}
    ];

    const customer_options = [
        {value: 'C000000011', name: 'Amazon'},
        {value: 'C000000004', name: 'Chewy'},
    ];

    const get3PLOrders = async () => {
        props.setLoading(true);
        try {
            const start = startDate?.full 
            ? startDate.full.clone().set({ hour: 0, minute: 0, second: 0, millisecond: 0 }).toDate() 
            : moment().clone().startOf('day').toDate();

            const end = endDate?.full 
            ? endDate.full.clone().set({ hour: 23, minute: 59, second: 59, millisecond: 999 }).toDate() 
            : moment().clone().endOf('day').toDate();

            let orders = [];
            if(warehouse === 10) orders = await tplHelpers.get3PLOrders(start, end, warehouse, customer, props.company, props.token);
            else{
                orders = await tplHelpers.getPOsForNovato(start, end, warehouse, customer, props.company, props.token);
                console.log("orders",orders);
            }

            if (orders.isAxiosError) {
                alert("Encountered an error while retrieving 3PL orders");
                console.log(orders);
            } else if (orders.length) {
                let formatted_orders = await formatOrders(orders, customer);
                setOrders(formatted_orders);
            } else if (orders.length === 0) {
                props.toast.error(`There are no ${(warehouse_options.find(option => option.value === warehouse))?.name} ${(customer_options.find(option => option.value === customer))?.name} orders in that date range.`);
            };
        } 
        catch (err) {
            console.log(err);
        }  
        finally {
            props.setLoading(false);
        }
    }

    const formatOrders = async (orders, customer) => {
        let sos = {};
        console.log(customer);
        for(let order of orders) {
            const so = order.OrderNbr?.value;
            if (!(so in sos)) {
                sos[so] = {
                    so_number: so,
                    po_number: order.CustomerOrderNbr?.value,
                    due_date: order.RequestedOn?.value,
                    ship_to_address: {
                        name: order.Location?.value,
                        address: order.AddressLine1?.value,
                        address_2: order.AddressLine2?.value,
                        city: order.City?.value,
                        state: order.State?.value,
                        zip_code: order.PostalCode?.value,
                        country: order.Country?.value,
                    },
                    bill_to_address: {
                        name: 'Amazon',
                        account_number: '00001',
                        address: order.BillToAddressLine1?.value,
                        address_2: order.BillToAddressLine2?.value,
                        city: order.BillToCity?.value,
                        state: order.BillToState?.value,
                        zip_code: order.BillToPostalCode?.value,
                        country: order.BillToCountry?.value, 
                    },
                    items: []
                }
            }
            let sku = order.InventoryID.value;
            if(!(sku in sos[so].items)) {
                sos[so].items.push({
                    sku: sku,
                    order_qty: order.Quantity?.value,
                    uom: order.UOM?.value,
                    price: order.UnitPrice?.value
                });
            }
        }
        let out = [];
        let id = 1;
        for (let so in sos) {
            sos[so].id = id;
            out.push(sos[so]);
            id++;
        }
        console.log(out);
        console.log(JSON.stringify(out));
        return out;
    }

    const getTotals = async () => {

        // number of SOs
        const total_num_sos = orders.length;
        const formatted_num_sos = new Intl.NumberFormat('en-US').format(total_num_sos); 
        setTotalSalesOrders(formatted_num_sos);

        // total quantity
        let total_qty = 0;
        for (let order of orders) {
            for (let item of order.items) {
                total_qty += item.order_qty;
            };
        };

        const formatted_quantity = new Intl.NumberFormat('en-US').format(total_qty); 
        setTotalQuantity(formatted_quantity);

        // total cost
        let total_price = 0;
        for (let order of orders) {
            for (let item of order.items) {
                const price = item.price;
                const qty = item.order_qty;
                total_price += (price * qty)
            };
        };
        const formatted_price = new Intl.NumberFormat('en-US', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }).format(total_price);
    
        setTotalCost(formatted_price);

    }

    useEffect(() => {
        getTotals();
    }, [orders]);

    useEffect(() => {
        setOrders([]);
    }, [startDate, endDate]);

    const sendOrdersTo3pl = async () => {
        props.setLoading(true);
        let tplResponse = ''
        if(warehouse === 10)
        {
            tplResponse = await tplHelpers.sendOrdersTo3pl(orders, props.company, props.token);
        }
        else if(warehouse === 50)
        {
            console.log("1",orders);
            console.log("2",startDate);
            tplResponse = await tplHelpers.sendOrdersToNovato(startDate, orders, props.company, props.token);
        }
        props.setLoading(false);
        if (tplResponse.success && warehouse === 10) {
            window.alert("Orders sent to Geodis.");
        } 
        if (tplResponse.success && warehouse === 50) {
            window.alert("Orders sent to Pet Factory.");
        } else {
            console.log(tplResponse.error);
            alert("Encountered an error while sending orders to 3PL");
        }      

    };

    return (
        <Box display = "flex" flexDirection = "column" className = {props.isMobile ? "mobile-top" : "desktop-top"}>
            <Box className = {props.isMobile ? "mobile-box" : "desktop-box"} sx = {{paddingLeft: 3}}>
                <h1>3PL Orders</h1> 
                <ThirdPartyLogisticsOrdersForm
                    get3PLOrders = {get3PLOrders}
                    handleDateChange = {handleDateChange}
                    startDate = {startDate?.full}
                    endDate = {endDate?.full}
                    orders = {orders}
                    warehouse = {warehouse}
                    setWarehouse = {setWarehouse}
                    warehouse_options = {warehouse_options}
                    customer = {customer}
                    setCustomer = {setCustomer}
                    customer_options = {customer_options}
                 />
            {
                orders.length > 0 ? (
                    <Box display = "flex" flexWrap = "wrap" gap = {2} sx = {{mt: '20px'}}>
                        <Box flexBasis = {{ xs: '50%', sm: '20%' }}>
                            <Card>
                                <CardContent>
                                <Typography gutterBottom>
                                    Number of Sales Orders:
                                </Typography>
                                <Typography 
                                    sx = {{ fontWeight: 'bold', fontSize: '1.25rem' }}
                                >
                                    {totalSalesOrders} orders
                                </Typography>
                                </CardContent>
                            </Card>
                        </Box>
                        <Box flexBasis = {{ xs: '50%', sm: '20%' }}>
                            <Card>
                                <CardContent>
                                <Typography gutterBottom>
                                    Total Quantity:
                                </Typography>
                                <Typography 
                                    sx = {{ fontWeight: 'bold', fontSize: '1.25rem' }}
                                >
                                    {totalQuantity} units
                                </Typography>
                                </CardContent>
                            </Card>
                        </Box>
                        <Box flexBasis = {{ xs: '50%', sm: '20%' }}>
                            <Card>
                                <CardContent>
                                <Typography gutterBottom>
                                    Total:
                                </Typography>
                                <Typography 
                                    sx = {{ fontWeight: 'bold', fontSize: '1.25rem' }} 
                                >
                                    ${totalCost}
                                </Typography>
                                </CardContent>
                            </Card>
                        </Box>
                        <Box flexBasis = "100%" sx = {{mt: '20px'}}>
                            <Button onClick = {sendOrdersTo3pl} sx = {{ ml: '10px' }} disabled = {props.isLoading} variant = "contained" color = "primary">
                                Send Orders to {(warehouse_options.find(option => option.value === warehouse))?.name}
                            </Button>
                        </Box>
                    </Box>
                    
                ) : null
            }
            </Box>
        </Box>
    )
}

export default ThirdPartyLogisticsOrders;